module.exports = __webpack_public_path__ + "img/sap.8c9da26d.png";